import template from './compareClubAuth.template.html';

export default {
  bindings: {
    onFinish: '&'
  },
  controller: class controller {
    constructor($mdDialog) {
      'ngInject';

      const ctrl = this;
      ctrl.$mdDialog = $mdDialog;

      ctrl.initialize = () => {
        $mdDialog
          .show({
            locals: {},
            template,
            controllerAs: '$ctrl',
            multiple: true,
            controller() {
              this.brokerCode = '';

              this.confirm = () => {
                $mdDialog.hide({ brokerCode: this.brokerCode });
              };
              this.cancel = () => {
                $mdDialog.hide(false);
              };
            },
            clickOutsideToClose: false
          })
          .then((res) => {
            ctrl.onFinish({ status: res });
          });
      };

      ctrl.$onInit = () => {
        ctrl.initialize();
      };
    }
  }
};
